<script setup lang="ts">
import TermsAndConditionsText from "./TermsAndConditionsText.vue";
</script>
<template>
    <div class="m-container flex justify-center">
        <TermsAndConditionsText />
    </div>
</template>
<style scoped></style>
